import React, { Dispatch, SetStateAction } from "react";
import { Field, Form, Formik } from "formik";
import parseHtml from "html-react-parser";
import { makeStyles } from "@mui/styles";
import { Button, TextField } from "@mui/material";
import { CredentialResponse, UserPermissions, LoginSupportInfoFormActions, Brand, Partition } from "../../services/Types";
import PermissionCheck from "../PermissionCheck";
import FormActionStatusIcon from "../FormActionStatusIcon/FormActionStatusIcon";
import UserCredentialsApi from "../../services/Api";
import { usernameUpdateFormValidationSchema } from "../../services/ValidationSchemas";

const useStyles = makeStyles({
  fieldErrorsHolder: {
    position: "relative",
    padding: "0 0 7px 25px",
    color: "#D80443",
    "& i": {
      position: "absolute",
      top: "0",
      left: "0",
    },
  },
  oktaUserUsername: {
    paddingLeft: "13px",
    marginTop: "10px"
  }
});

export const LoginUsernameForm = ({
  userCredentials,
  formActionsStatus,
  executeFormAction,
  userPermissions,
  userCredentialsApi,
  brand,
  errorOutlines,
  setErrorOutlines
}: {
  userCredentials: CredentialResponse,
  formActionsStatus: LoginSupportInfoFormActions,
  executeFormAction: any,
  userPermissions: Array<UserPermissions>,
  userCredentialsApi: UserCredentialsApi,
  brand?: Brand,
  errorOutlines: any,
  setErrorOutlines: Dispatch<SetStateAction<any>>
}) => {
  const classes = useStyles();

  const isOktaUser = userCredentials?.partition === Partition.OKTA;

  return (
    <Formik
      initialValues={{
        username: userCredentials.username
      }}
      validationSchema={usernameUpdateFormValidationSchema}
      onSubmit={(values, actions) => {
        executeFormAction({
          credentialId: userCredentials.id,
          action: "updateUsername",
          apiMethodToCall:
            userCredentialsApi.updateUserCredentialsWithId,
          updateCredentialsPayload: {
            id: userCredentials.id,
            username: values.username,
          },
          valueName: "username",
          setErrors: actions.setErrors
        })
      }}
    >
      {({ values, errors, handleChange, handleSubmit }) => {
        return (
          <Form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="username">Username</label>
            {
              isOktaUser ?
                <>
                  <p className={classes.oktaUserUsername}>{userCredentials?.username}</p>
                </>
              :
                <>
                  <Field
                  className={errorOutlines["username"] ? "errorOutline" : ""}
                    component={TextField}
                    name="username"
                    id="username"
                    type="text"
                    variant="outlined"
                    fullWidth
                    value={values.username}
                    onChange={handleChange}
                  />
                  {errors.username && (
                    <div>
                      <div className={classes.fieldErrorsHolder}>
                        <i className="t-error"></i>
                        {parseHtml(errors.username)}
                      </div>
                    </div>
                  )}
                  <PermissionCheck
                    userPermissions={userPermissions}
                    permissionToCheck={
                      UserPermissions.UPDATE_USERNAME_EDIT
                    }
                  >
                    <Button
                      variant="outlined"
                      type="submit"
                    >
                      Update Username
                    </Button>
                    <FormActionStatusIcon
                      brand={brand}
                      status={formActionsStatus.updateUsername}
                    />
                  </PermissionCheck>
                </>
            }
            
          </div>
      
        </Form>
      )}}
    </Formik>
  );
}